<table mat-table matSort [dataSource]="dataSource">
  <ng-container matColumnDef="actionNumber">
    <th class="w-12" mat-header-cell *matHeaderCellDef mat-sort-header>
      Court case
    </th>
    <td class="w-12" mat-cell *matCellDef="let e">
      {{ e.actionNumber ? e.actionNumber : e.styleOfCause }}
    </td>
  </ng-container>

  <ng-container matColumnDef="styleOfCause">
    <th class="soc" mat-header-cell *matHeaderCellDef mat-sort-header>
      Style of cause
    </th>
    <td class="soc" mat-cell *matCellDef="let e">
      {{ e.styleOfCause }}
    </td>
  </ng-container>

  <ng-container matColumnDef="jurisdiction">
    <th class="w-10" mat-header-cell *matHeaderCellDef mat-sort-header>
      Judicial centre
    </th>
    <td class="w-10" mat-cell *matCellDef="let e">
      {{ e.jurisdiction | incomplete }}
    </td>
  </ng-container>

  <ng-container matColumnDef="category">
    <th class="w-12" mat-header-cell *matHeaderCellDef mat-sort-header>
      Category
    </th>
    <td class="w-12" mat-cell *matCellDef="let e">
      {{ e.civilMatterType | incomplete }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let e; columns: displayedColumns"
    (click)="onView(e)"
  ></tr>
</table>

<div *ngIf="tableData.length <= 0" fxLayoutAlign="center center" class="mt-20">
  <button mat-flat-button color="primary" class="mr-2" disabled>
    No items
  </button>
</div>

<mat-paginator
  [pageSizeOptions]="[5, 10, 20]"
  [pageSize]="pageInfo?.pageSize"
  showFirstLastButtons
  (page)="onPageChange($event)"
></mat-paginator>
